const CardOrRibbon = Object.freeze({
  CARD: 'card',
  RIBBON: 'ribbon',
  NONE: 'none',
})

export default CardOrRibbon
